var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditThinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2227 6.71773L7.13961 17.8008C6.80026 18.1401 6.34002 18.3307 5.86011 18.3307H2.99067C2.49101 18.3307 2.08594 17.9257 2.08594 17.426V14.5566C2.08594 14.0766 2.27657 13.6164 2.61592 13.2771L13.699 2.19405C14.4056 1.4874 15.5513 1.4874 16.2579 2.19405L18.2227 4.15875C18.9293 4.86539 18.9293 6.01109 18.2227 6.71773ZM12.3923 5.4199L14.9968 8.02435L6.17999 16.8411C6.09515 16.926 5.98009 16.9736 5.86011 16.9736H3.44304V14.5566C3.44304 14.4366 3.49071 14.3215 3.57554 14.2367L12.3923 5.4199ZM13.352 4.46027L15.9564 7.06473L17.263 5.75811C17.4397 5.58146 17.4397 5.29502 17.263 5.11837L15.2984 3.15367C15.1217 2.977 14.8352 2.977 14.6586 3.15367L13.352 4.46027Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditThinIcon);
export default __webpack_public_path__ + "static/media/edit-thin-icon.b993dcc939f1e41a8e50f4bd7ee16591.svg";
export { ForwardRef as ReactComponent };